<p-dialog
  header="{{ 'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.BENEFICIARY_DIALOG.HEADER' | translate }}"
  [(visible)]="display"
  [modal]="true"
  [draggable]="false"
  class="admin-dialog">
  <form [formGroup]="beneficiaryForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.BENEFICIARY_DIALOG.BENEFICIARY_TYPE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="beneficiaryForm.get('beneficiaryCategoryType')">
              <p-autoComplete
                formControlName="beneficiaryCategoryType"
                [suggestions]="filteredTypes"
                [dropdown]="true"
                (completeMethod)="filterTypes($event)">
              </p-autoComplete>
            </wsd-extended-input>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.BENEFICIARY_DIALOG.BENEFICIARY_SUBTYPE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <wsd-extended-input [control]="beneficiaryForm.get('beneficiaryCategorySubType')">
              <p-autoComplete
                formControlName="beneficiaryCategorySubType"
                [suggestions]="filteredSubTypes"
                [dropdown]="true"
                (completeMethod)="filterSubTypes($event)">
              </p-autoComplete>
            </wsd-extended-input>
          </div>
        </div>
      </div>
          <div class="ui-g-12">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.BENEFICIARY_DIALOG.BENEFICIARY_CATEGORY' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <wsd-extended-input [control]="beneficiaryForm.get('beneficiaryCategoryCategory')">
                  <input pInputText
                         formControlName="beneficiaryCategoryCategory"/>
                </wsd-extended-input>
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.BENEFICIARY_DIALOG.CATEGORY_DESTINATION' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <wsd-extended-input [control]="beneficiaryForm.get('beneficiaryCategoryDescription')">
                  <textarea pInputTextarea
                            autoResize="true"
                            formControlName="beneficiaryCategoryDescription"
                            rows="5"
                            resizable="true">
                  </textarea>
                </wsd-extended-input>
              </div>
            </div>
          </div>
          <div class="ui-g-12">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.BENEFICIARY_DIALOG.ESTIMATION_GUIDANCE' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <wsd-extended-input [control]="beneficiaryForm.get('beneficiaryCategoryGuidance')">
                  <textarea pInputTextarea
                            autoResize="true"
                            formControlName="beneficiaryCategoryGuidance"
                            rows="5"
                            resizable="true">
                  </textarea>
                </wsd-extended-input>
              </div>
            </div>
          </div>
          <div class="ui-g-5"></div>
          <div class="ui-g-7">
            <button pButton class="ui-button-success inline-block m-r-15"
                    type="submit"
                    [label]="'DATA_PORTAL.ADMINISTRATION.CENSUS.CENSUS_DIALOG.SAVE_BUTTON' | translate"></button>
          </div>
        </div>
  </form>
</p-dialog>
